/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Updated_OnInputs */

const en_updated_on = /** @type {(inputs: Updated_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated On`)
};

const fr_updated_on = /** @type {(inputs: Updated_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mis à jour le`)
};

const de_updated_on = /** @type {(inputs: Updated_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualisiert am`)
};

const it_updated_on = /** @type {(inputs: Updated_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiornato il`)
};

const ru_updated_on = /** @type {(inputs: Updated_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновлено`)
};

const es_updated_on = /** @type {(inputs: Updated_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizado el`)
};

const zh_cn2_updated_on = /** @type {(inputs: Updated_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新于`)
};

const ja_updated_on = /** @type {(inputs: Updated_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新日`)
};

const hi_updated_on = /** @type {(inputs: Updated_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`को अपडेट`)
};

const pt_pt2_updated_on = /** @type {(inputs: Updated_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizado em`)
};

/**
* | output |
* | --- |
* | "Updated On" |
*
* @param {Updated_OnInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const updated_on = /** @type {((inputs?: Updated_OnInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Updated_OnInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_updated_on(inputs)
	if (locale === "de") return de_updated_on(inputs)
	if (locale === "it") return it_updated_on(inputs)
	if (locale === "ru") return ru_updated_on(inputs)
	if (locale === "es") return es_updated_on(inputs)
	if (locale === "zh-CN") return zh_cn2_updated_on(inputs)
	if (locale === "ja") return ja_updated_on(inputs)
	if (locale === "hi") return hi_updated_on(inputs)
	if (locale === "pt-PT") return pt_pt2_updated_on(inputs)
	return en_updated_on(inputs)
});